import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { Loading } from 'receivable-invoices-js/react/components/shared/loading';
import { ResponsiveView } from 'receivable-invoices-js/react/components/shared/responsive-view';
import { useRouteQuery } from './use-route-query';
import styles from './layout.module.css';

export function QuotesIndexRoute(): ReactNode {
  const { quote, attachments, isClientPortalEnabled, isLoading, isError } = useRouteQuery();

  if (isLoading) {
    return <Loading spinnerSize="large" />;
  }

  if (isError || !quote) {
    return <Navigate replace to="/404" />;
  }

  return (
    <div className={styles.errorStateContainer}>
      <ResponsiveView
        attachments={attachments}
        data-test-quote-responsive-view=""
        document={quote}
        isClientPortalEnabled={isClientPortalEnabled}
        type="quote"
      />
    </div>
  );
}
